const PLACEMENT_ROLES = {
  12: {
    name: "START",
    color: [0, 255, 0, 64],
  },
  13: {
    name: "MIDDLE",
    color: [0, 0, 255, 64],
  },
  14: {
    name: "FINISH",
    color: [255, 0, 0, 64],
  },
  15: {
    name: "FOOT",
    color: [255, 255, 0, 64],
  },
}

const DEFAULT_ANGLE = 50

export { PLACEMENT_ROLES, DEFAULT_ANGLE }
